import { createClient } from '@/shared/api';
import IMPORT_C1C_STUDY_MUTATION from '../mutations/importC1cStudy';

type ImportC1cStudyErrorCode = 'NOT_FOUND' | 'UPSTREAM_ERROR';

type ImportC1cStudyResult =
  | { isSuccess: true; study: { id: string; friendlyId: number } }
  | { isSuccess: false; errorCode: ImportC1cStudyErrorCode };

interface ImportC1cStudyMutation {
  importC1cStudy: ImportC1cStudyResult;
}

/**
 * Imports a CardioOne-managed study by its external ID. Runs IMPORT_C1C_STUDY_MUTATION and returns the importC1cStudy payload; a refusal comes back as a result, while Apollo network and GraphQL errors throw.
 *
 * @param externalId - CardioOne study ID, already trimmed; sent as typed, case preserved.
 * @returns The imported study, or the refusal code.
 */
const handleImportC1cStudy = async (externalId: string): Promise<ImportC1cStudyResult> => {
  const client = createClient();
  const importResult = await client.mutate<ImportC1cStudyMutation, { externalId: string }>({
    mutation: IMPORT_C1C_STUDY_MUTATION,
    variables: { externalId },
  });
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  return importResult.data!.importC1cStudy;
};

export default handleImportC1cStudy;
export type { ImportC1cStudyResult };
